const x = {
  xxs: 0,
  xs: 568,
  s: 768,
  ssm: 960,
  sm: 1280,
  m: 1024,
  xm: 1366,
  l: 1440,
  xl: 1680,
  xxl: 1920
};
export {
  x as BREAKPOINTS
};
